import React from 'react';
import Button from '../../../components/base/Button';

const ServicesSection: React.FC = () => {
  const services = [
    {
      icon: 'ri-book-open-line',
      title: 'Öğrenci Koçluğu',
      description: 'Akademik başarı, motivasyon artırma, zaman yönetimi ve sınav kaygısı konularında öğrencilere destek.',
      features: [
        'Akademik hedef belirleme',
        'Çalışma teknikleri geliştirme',
        'Sınav kaygısı yönetimi',
        'Motivasyon artırma',
        'Zaman planlaması'
      ],
      color: 'teal',
      image: 'https://public.readdy.ai/ai/img_res/c1d90616c12ecd4f386a06419e6a4ced.jpg'
    },
    {
      icon: 'ri-parent-line',
      title: 'Ebeveyn Koçluğu',
      description: 'Çocukla etkili iletişim, eğitim süreçlerinde rehberlik ve aile dinamiklerini güçlendirme.',
      features: [
        'Etkili ebeveyn iletişimi',
        'Çocuk gelişimi rehberliği',
        'Aile dinamikleri',
        'Eğitim süreç yönetimi',
        'Davranış geliştirme'
      ],
      color: 'blue',
      image: 'https://readdy.ai/api/search-image?query=Parent%20coaching%20consultation%20with%20family%20dynamics%20focus%2C%20warm%20family%20environment%2C%20professional%20coaching%20setting%2C%20soft%20blue%20lighting%2C%20communication%20and%20understanding%20concept%2C%20modern%20home%20office%2C%20supportive%20atmosphere%2C%20high%20quality%20photography&width=400&height=300&seq=parent-coaching&orientation=landscape'
    },
    {
      icon: 'ri-briefcase-line',
      title: 'Kariyer Koçluğu',
      description: 'Meslek seçimi, kariyer geçişi, iş hayatında hedef belirleme ve kişisel gelişim desteği.',
      features: [
        'Kariyer planlama',
        'Meslek seçimi rehberliği',
        'İş değişikliği desteği',
        'Liderlik geliştirme',
        'Kişisel marka oluşturma'
      ],
      color: 'purple',
      image: 'https://readdy.ai/api/search-image?query=Career%20coaching%20session%20in%20professional%20office%20setting%2C%20business%20professional%20with%20coach%2C%20modern%20workspace%20with%20purple%20accents%2C%20career%20development%20and%20growth%20concept%2C%20clean%20corporate%20environment%2C%20success%20and%20achievement%20atmosphere&width=400&height=300&seq=career-coaching&orientation=landscape'
    }
  ];

  const getColorClasses = (color: string) => {
    const colors = {
      teal: {
        bg: 'bg-teal-50',
        icon: 'text-teal-600',
        iconBg: 'bg-teal-100',
        button: 'bg-teal-600 hover:bg-teal-700',
        accent: 'text-teal-600'
      },
      blue: {
        bg: 'bg-blue-50',
        icon: 'text-blue-600',
        iconBg: 'bg-blue-100',
        button: 'bg-blue-600 hover:bg-blue-700',
        accent: 'text-blue-600'
      },
      purple: {
        bg: 'bg-purple-50',
        icon: 'text-purple-600',
        iconBg: 'bg-purple-100',
        button: 'bg-purple-600 hover:bg-purple-700',
        accent: 'text-purple-600'
      }
    };
    return colors[color as keyof typeof colors];
  };

  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-900 mb-6">
            Koçluk <span className="text-teal-600">Hizmetlerim</span>
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            ICF standartlarına uygun, bilimsel yaklaşımla desteklenen koçluk hizmetleri ile 
            yaşamınızın her alanında hedeflerinize ulaşmanızı destekliyorum.
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
          {services.map((service, index) => {
            const colors = getColorClasses(service.color);
            return (
              <div key={index} className={`${colors.bg} rounded-2xl p-8 hover:shadow-xl transition-all duration-300`}>
                <div className="mb-6">
                  <img
                    src={service.image}
                    alt={`${service.title} - Profesyonel koçluk hizmetleri`}
                    className="w-full h-48 object-cover rounded-xl mb-6 object-top"
                  />
                  <div className={`w-16 h-16 ${colors.iconBg} rounded-full flex items-center justify-center mb-4`}>
                    <i className={`${service.icon} ${colors.icon} text-2xl`}></i>
                  </div>
                  <h3 className="text-2xl font-bold text-gray-900 mb-4">{service.title}</h3>
                  <p className="text-gray-700 mb-6 leading-relaxed">{service.description}</p>
                </div>

                <div className="mb-8">
                  <h4 className="font-semibold text-gray-900 mb-4">Hizmet Kapsamı:</h4>
                  <ul className="space-y-2">
                    {service.features.map((feature, idx) => (
                      <li key={idx} className="flex items-center space-x-2">
                        <i className={`ri-check-line ${colors.accent} text-sm`}></i>
                        <span className="text-gray-700 text-sm">{feature}</span>
                      </li>
                    ))}
                  </ul>
                </div>

                <Button 
                  href="/ucretsiz-gorusme"
                  className={`w-full ${colors.button} text-white`}
                >
                  Detayları İncele
                </Button>
              </div>
            );
          })}
        </div>

        <div className="text-center mt-16">
          <div className="bg-gradient-to-r from-teal-50 to-blue-50 rounded-2xl p-8">
            <h3 className="text-2xl font-bold text-gray-900 mb-4">
              Koçluk Sürecim Nasıl İşler?
            </h3>
            <div className="grid grid-cols-1 md:grid-cols-4 gap-6 mt-8">
              <div className="text-center">
                <div className="w-16 h-16 bg-teal-600 rounded-full flex items-center justify-center mx-auto mb-4">
                  <span className="text-white font-bold text-xl">1</span>
                </div>
                <h4 className="font-semibold text-gray-900 mb-2">Ücretsiz Ön Görüşme</h4>
                <p className="text-sm text-gray-600">İhtiyaçlarınızı anlayalım</p>
              </div>
              <div className="text-center">
                <div className="w-16 h-16 bg-blue-600 rounded-full flex items-center justify-center mx-auto mb-4">
                  <span className="text-white font-bold text-xl">2</span>
                </div>
                <h4 className="font-semibold text-gray-900 mb-2">Hedef Belirleme</h4>
                <p className="text-sm text-gray-600">Net hedefler koyalım</p>
              </div>
              <div className="text-center">
                <div className="w-16 h-16 bg-purple-600 rounded-full flex items-center justify-center mx-auto mb-4">
                  <span className="text-white font-bold text-xl">3</span>
                </div>
                <h4 className="font-semibold text-gray-900 mb-2">Koçluk Seansları</h4>
                <p className="text-sm text-gray-600">Düzenli görüşmeler</p>
              </div>
              <div className="text-center">
                <div className="w-16 h-16 bg-green-600 rounded-full flex items-center justify-center mx-auto mb-4">
                  <span className="text-white font-bold text-xl">4</span>
                </div>
                <h4 className="font-semibold text-gray-900 mb-2">Başarı</h4>
                <p className="text-sm text-gray-600">Hedeflerinize ulaşın</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ServicesSection;